import { ReactElement } from 'react'
import { Field } from 'react-final-form'
import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField'
import { useMessageSource } from 'src/i18n/useMessageSource'

export interface NumberFieldProps extends Omit<MuiTextFieldProps, 'name' | 'type' | 'variant'> {
  name: string
  validate?: any
  variant?: 'standard' | 'filled' | 'outlined'
}

export const NumberField = (props: NumberFieldProps): ReactElement => {
  const { name, validate, variant, ...rest } = props
  const { getMessage } = useMessageSource()

  return (
    <Field
      name={name}
      validate={validate}
      render={({ input: { value, onChange, onFocus, onBlur }, meta: { touched, error: errorObject } }) => {
        const error = errorObject && getMessage(errorObject.errorKey, errorObject.params)
        const invalid = Boolean(touched && error)

        return (
          <MuiTextField
            {...rest}
            fullWidth
            name={name}
            type="number"
            helperText={(invalid && error) || ' '}
            error={invalid}
            value={value}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            autoComplete="nope"
            variant={variant}
          />
        )
      }}
    />
  )
}
